<template>
  <section class="my-prospecting-layout">
    <section class="sidebar">
      <my-prospecting-sidebar-element />
    </section>

    <section class="main">
      <slot />
    </section>
  </section>
</template>

<script>
import MyProspectingSidebarElement from '@/components/elements/MyProspectingSidebarElement';

export default {
  name: 'SequenceLayout',
  components: {
    MyProspectingSidebarElement,
  },
};
</script>

<style lang="scss" scoped>
@import '@/constants/variables.module.scss';
.my-prospecting-layout {
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
}
.sidebar {
  border-right: 1px solid $medium-gray;
  padding: 28px 0 0 24px;
  width: 272px;
  display: flex;
  flex-flow: column;
  min-height: 100vh;
}
.main {
  width: calc(100% - 272px);
  min-width: 300px;
}
</style>
